import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'fi-checklist-report-view-checkpoints-per-unit-table-cell-view',
    template: `
@switch (column.type) {
  @case ('textPlain') {
    <ng-container *ngTemplateOutlet="TextPlain"></ng-container>
  }
  @case ('text') {
    <ng-container *ngTemplateOutlet="Text"></ng-container>
  }
  @case ('array') {
    <ng-container *ngTemplateOutlet="Array"></ng-container>
  }
  @default {
    <ng-container *ngTemplateOutlet="Empty"></ng-container>
  }
}
<ng-template #TextPlain>
  <fi-checklist-report-view-checkpoints-per-unit-table-cell-view-text-plain
    [column]="column"
    [data]="data"
    (cellClick)="onCellClick($event)"
    >
  </fi-checklist-report-view-checkpoints-per-unit-table-cell-view-text-plain>
</ng-template>
<ng-template #Text>
  <fi-checklist-report-view-checkpoints-per-unit-table-cell-view-text
    [column]="column"
    [data]="data"
    (cellClick)="onCellClick($event)"
    >
  </fi-checklist-report-view-checkpoints-per-unit-table-cell-view-text>
</ng-template>
<ng-template #Array>
  <fi-checklist-report-view-checkpoints-per-unit-table-cell-view-array
    [column]="column"
    [data]="data"
    (cellClick)="onCellClick($event)"
    >
  </fi-checklist-report-view-checkpoints-per-unit-table-cell-view-array>
</ng-template>
<ng-template #Empty>
  <fi-checklist-report-view-checkpoints-per-unit-table-cell-view-empty
    [column]="column"
    [data]="data"
    (cellClick)="onCellClick($event)"
    >
  </fi-checklist-report-view-checkpoints-per-unit-table-cell-view-empty>
</ng-template>
`,
    standalone: false,
})
export class CellViewComponent {
    @Input() column;
    @Input() data;

    @Output() cellClick = new EventEmitter();

    onCellClick($event) {
        this.cellClick.emit($event);
    }
}
